import DirectiveComplexityFormStepCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/DirectiveComplexityFormStep/states/DirectiveComplexityFormStepCompleted'
import DirectiveComplexityFormStepPending from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/DirectiveComplexityFormStep/states/DirectiveComplexityFormStepPending'
import DirectiveDiagnosticFormStepCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/DirectiveDiagnosticFormStep/states/DirectiveDiagnosticFormStepCompleted'
import DirectiveDiagnosticFormStepPending from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/DirectiveDiagnosticFormStep/states/DirectiveDiagnosticFormStepPending'
import EstablishmentChoiceEntryFormStepCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/EstablishmentChoiceEntryFormStep/states/EstablishmentChoiceEntryFormStepCompleted'
import EstablishmentChoiceEntryFormStepPending from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/directivesFormSteps/EstablishmentChoiceEntryFormStep/states/EstablishmentChoiceEntryFormStepPending'
import { checkinEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant'
import CheckinEntryFormStepCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps/states/CheckinEntryFormStepCompleted'
import CheckinEntryFormStepPending from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps/states/CheckinEntryFormStepPending'
import { establishmentChoiceEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant'
import {
  MaintenanceForwardingsDirectiveFromSteps,
  MaintenanceForwardingsRequiredDirectiveStepsData,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import {
  checkinEntrySchema,
  directiveComplexitySchema,
  directiveDiagnosticSchema,
  establishmentChoiceEntrySchema,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { ZodTypeAny } from 'zod'

export const directiveEntryFormSteps: {
  [K in keyof MaintenanceForwardingsRequiredDirectiveStepsData]: {
    components: {
      pending: React.ComponentType<MaintenanceForwardingsDirectiveFormStepProps<K>>
      completed: React.ComponentType<MaintenanceForwardingsDirectiveFormStepProps<K>>
    }
    options: any
    schema: ZodTypeAny
  }
} = {
  [MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity]: {
    components: {
      pending: DirectiveComplexityFormStepPending,
      completed: DirectiveComplexityFormStepCompleted,
    },
    options: null,
    schema: directiveComplexitySchema,
  },
  [MaintenanceForwardingsDirectiveFromSteps.DirectiveDiagnostic]: {
    components: {
      pending: DirectiveDiagnosticFormStepPending,
      completed: DirectiveDiagnosticFormStepCompleted,
    },
    options: null,
    schema: directiveDiagnosticSchema,
  },
  [MaintenanceForwardingsDirectiveFromSteps.EstablishmentChoiceEntry]: {
    components: {
      pending: EstablishmentChoiceEntryFormStepPending,
      completed: EstablishmentChoiceEntryFormStepCompleted,
    },
    options: establishmentChoiceEntryOptions,
    schema: establishmentChoiceEntrySchema,
  },
  [MaintenanceForwardingsDirectiveFromSteps.CheckinEntry]: {
    components: {
      pending: CheckinEntryFormStepPending,
      completed: CheckinEntryFormStepCompleted,
    },
    options: checkinEntryOptions,
    schema: checkinEntrySchema,
  },
}
